// extracted by mini-css-extract-plugin
export default {"main":"Specials_main__GUV93","box":"Specials_box__Y-HsO","email":"Specials_email__BURmD","burger":"Specials_burger__474px","menu":"Specials_menu__rBw9c"};